import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Bundle } from '@paragon/contract-library';

import { scheduleGroupDeleted } from './scheduleGroupsSlice';
import { scheduleLineGroupDeleted } from './scheduleLineGroupsSlice';
import { truckloadCreated, truckloadDeleted } from './truckloadsSlice';

interface BundlesState {
  [bundleGuid: string]: Bundle;
}

const initialState: BundlesState = {};

const bundlesSlice = createSlice({
  name: 'bundles',
  initialState,
  reducers: {
    bundlesLoaded: (state, action: PayloadAction<readonly Bundle[]>) => {
      for (const bundle of action.payload) {
        state[bundle.guid] = castDraft(bundle);
      }
    },
    bundleCreated: (state, action: PayloadAction<Bundle>) => {
      state[action.payload.guid] = castDraft(action.payload);
    },
    bundleDeleted: (state, action: PayloadAction<Bundle>) => {
      delete state[action.payload.guid];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(truckloadCreated, (state, action) => {
      const { bundleGuids, truckload } = action.payload;
      for (const bundleGuid of bundleGuids) {
        state[bundleGuid].truckloadGuid = truckload.guid;
      }
    });
    builder.addCase(truckloadDeleted, (state, action) => {
      for (const bundle of action.payload.updatedBundles) {
        state[bundle.guid] = bundle;
      }
    });
    builder.addCase(scheduleGroupDeleted, (state, action) => {
      for (const bundle of action.payload.updatedBundles) {
        state[bundle.guid] = bundle;
      }
    });
    builder.addCase(scheduleLineGroupDeleted, (state, action) => {
      for (const bundle of action.payload.updatedBundles) {
        state[bundle.guid] = bundle;
      }
    });
  },
});

export const { bundlesLoaded, bundleCreated, bundleDeleted } = bundlesSlice.actions;
export const bundles = bundlesSlice.reducer;
